import { useContext, useEffect, useState } from 'react'
import type { ChangeEvent } from 'react'
import styled from 'styled-components'

import { toast } from '../../../utils'

import { StoresContext } from '../../../provider/StoreProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Button } from '../../../components/button'
import { Input } from '../../../components/input'
import { Text } from '../../../components/text'
import { Footer } from '../../../components/footer'
import { Header } from '../../../components/header'

export const QnaRegister = () => {
  const { myStore } = useContext(StoresContext)

  const [validateStatus, setValidateStatus] = useState<boolean>(false)
  const [inputValues, setInputValues] = useState({
    title: '',
    content: '',
  })
  const { title, content } = inputValues

  const navigate = useNavigate()

  const validate = () => setValidateStatus(!!title && !!content)

  const onChangeInput = ({ currentTarget: { name, value } }: ChangeEvent<HTMLInputElement>) => {
    if (name === 'title' && value.length > 35) return
    setInputValues({ ...inputValues, [name]: value })
  }

  const onRegisterQna = async () => {
    try {
      await myStore.registerQna({ title, content })
      setInputValues({ title: '', content: '' })
      toast('✓ 문의사항 접수가 완료되었습니다.')
      navigate('/qna')
    } catch (error) {
      toast('문의사항 작성에 실패했어요.', error)
    }
  }

  useEffect(() => {
    validate()
  }, [title, content])

  return (
    <Wrap>
      <Header type="SUB" title="1:1문의하기" />
      <Content>
        <TitleContainer>
          <Text size={18} weight={600}>
            문의 제목
          </Text>
          <Input placeholder="제목을 입력해주세요. (최대 35자)" name="title" value={title} onChange={onChangeInput} />
        </TitleContainer>
        <ContentContainer>
          <Text size={18} weight={600}>
            문의 내용
          </Text>
          <Input.Textarea
            placeholder="내용을 입력해주세요."
            name="content"
            value={content}
            $height={400}
            onChange={onChangeInput}
          />
        </ContentContainer>
      </Content>
      <Footer>
        <Button type="primary" size="large" disabled={!validateStatus} block={true} onClick={onRegisterQna}>
          {validateStatus ? '문의하기' : '내용을 입력해주세요.'}
        </Button>
      </Footer>
    </Wrap>
  )
}

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 20px;
`
